import { createContext } from "react";

/** Keep expensive visual resources prepared while animation and interaction remain inactive. */
export const VisualResourcePreparationContext = createContext(false);
